export default {
  account: {
    'zh-cn': '账号：',
    'zh-tw': '賬號：',
    'en': 'Account:'
  },
  company: {
    'zh-cn': '所属企业：',
    'zh-tw': '所屬企業：',
    'en': 'Company:'
  },
  updatePassword: {
    'zh-cn': '修改密码',
    'zh-tw': '修改密碼',
    'en': 'Change Password'
  },
  logout: {
    'zh-cn': '退出登录',
    'zh-tw': '退出登錄',
    'en': 'Logout'
  },
  logoutConfirm: {
    'zh-cn': '确认退出登录',
    'zh-tw': '確認退出登錄',
    'en': 'Confirm logout'
  },
  updatePasswordTitle: {
    'zh-cn': '修改密码',
    'zh-tw': '修改密碼',
    'en': 'Change Password'
  },
  oldPasswordPlaceholder: {
    'zh-cn': '请输入旧密码',
    'zh-tw': '請輸入舊密碼',
    'en': 'Please enter old password'
  },
  newPasswordPlaceholder: {
    'zh-cn': '请输入密码',
    'zh-tw': '請輸入密碼',
    'en': 'Please enter password'
  },
  confirmPasswordPlaceholder: {
    'zh-cn': '请再次输入密码',
    'zh-tw': '請再次輸入密碼',
    'en': 'Please enter password again'
  },
  updateSuccess: {
    'zh-cn': '修改成功',
    'zh-tw': '修改成功',
    'en': 'Update successful'
  },
  passwordNotMatch: {
    'zh-cn': '两次输入密码不同',
    'zh-tw': '兩次輸入密碼不同',
    'en': 'The two passwords do not match'
  },
  validation: {
    passwordRequired: {
      'zh-cn': '请输入密码',
      'zh-tw': '請輸入密碼',
      'en': 'Please enter password'
    },
    passwordMinLength: {
      'zh-cn': '密码最小长度6个字符',
      'zh-tw': '密碼最小長度6個字符',
      'en': 'Password minimum length is 6 characters'
    },
    passwordMaxLength: {
      'zh-cn': '密码最大长度32个字符',
      'zh-tw': '密碼最大長度32個字符',
      'en': 'Password maximum length is 32 characters'
    },
    passwordNotMatch: {
      'zh-cn': '两次密码输入不一致',
      'zh-tw': '兩次密碼輸入不一致',
      'en': 'The two passwords do not match'
    }
  }
}

